import { Theme } from "@mui/material";

export const modalWrapperStyles = (theme: Theme, md: number = 2) => ({
  flex: { xs: "unset", md: md },
  backgroundColor: theme.palette.modalColors.bgBlockColor,
  padding: "16px",
  borderRadius: "16px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
});

export const innerWrapperStyles = (isColumn: boolean) => ({
  p: 2,
  ...(isColumn && {
    display: "flex",
    flexDirection: "column",
  }),
});

export const textStyle = (theme: Theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: "16px",
  color: theme.palette.modalColors.colorLable,
});
